(function () {
    'use strict';

    angular.module("imApp").factory("colorGrpsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1205,
                    parameters: parms || {}
                });
            },
            listColourGroupViews: function (parms) {
                return $ihttp.post({
                    method: 1204,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
